import { useCallback, useEffect } from 'react'
import { isMobile } from 'react-device-detect'
import {
  SUBTITLE_COLOR,
  SUBTITLE_FONT_FAMILY,
  SUBTITLE_FONT_WEIGHT,
  SUBTITLE_LINE_HEIGHT,
  SUBTITLE_TEXT_SHADOW,
  SizeTier,
  calcSubtitleFontSize,
} from '~/styles/subtitleStyle'

export const useCueFontSizeOptimizer = (sizeTier: SizeTier) => {
  const getActiveDisplayWidth = useCallback(() => {
    const video = document.querySelector('video')

    if (!video) return 0

    const videoAspectRatio = video.videoWidth / video.videoHeight // 元動画のアスペクト比
    const displayAspectRatio = video.clientWidth / video.clientHeight // 表示領域のアスペクト比

    return videoAspectRatio > displayAspectRatio
      ? video.clientWidth
      : video.clientHeight * videoAspectRatio
  }, [])

  const updateCueFontSize = useCallback(() => {
    const activeDisplayWidth = getActiveDisplayWidth()

    if (activeDisplayWidth === 0) return

    const isFs =
      !!document.fullscreenElement ||
      !!(document as any).webkitFullscreenElement
    const fontSize = calcSubtitleFontSize(activeDisplayWidth, isFs, sizeTier)

    let styleElement = document.getElementById('global-cue-style')
    if (!styleElement) {
      styleElement = document.createElement('style')
      styleElement.id = 'global-cue-style'
      document.head.appendChild(styleElement)
    }

    styleElement.innerHTML = `
        video::cue {
          font-size: ${fontSize}px;
          font-family: ${SUBTITLE_FONT_FAMILY};
          font-weight: ${SUBTITLE_FONT_WEIGHT};
          text-shadow: ${SUBTITLE_TEXT_SHADOW};
          line-height: ${SUBTITLE_LINE_HEIGHT};
          color: ${SUBTITLE_COLOR};
        }
        .plyr__captions .plyr__caption {
          font-size: ${fontSize}px !important;
          font-family: ${SUBTITLE_FONT_FAMILY} !important;
          font-weight: ${SUBTITLE_FONT_WEIGHT} !important;
          text-shadow: ${SUBTITLE_TEXT_SHADOW} !important;
          line-height: ${SUBTITLE_LINE_HEIGHT} !important;
          color: ${SUBTITLE_COLOR} !important;
        }
      `
  }, [getActiveDisplayWidth, sizeTier])

  useEffect(() => {
    updateCueFontSize()

    const handleResize = () => {
      !isMobile && updateCueFontSize() // 画面回転時にもresizeイベントが発火するため、isMobileの場合は無視
    }
    window.addEventListener('resize', handleResize)
    document.addEventListener('fullscreenchange', handleResize)
    document.addEventListener('webkitfullscreenchange', handleResize)

    const observer = new MutationObserver(() => {
      const video = document.querySelector('video')
      if (video) {
        video.addEventListener('play', handleResize)
      }
    })
    observer.observe(document.body, { childList: true, subtree: true })

    return () => {
      window.removeEventListener('resize', handleResize)
      document.removeEventListener('fullscreenchange', handleResize)
      document.removeEventListener('webkitfullscreenchange', handleResize)
      observer.disconnect()
    }
  }, [updateCueFontSize])
}
